import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  margin: 0;
  overflow: hidden;
  display: flex;
  font-size: 1rem;
`;

export const ImageArea = styled.main`
  position: relative;
  width: 100%;
  img {
    width: 100%;
    height: 101vh;
    object-fit: cover;
    object-position: center;
  }
`;

export const TipBackground = styled.div`
  position: absolute;
  z-index: 1000;
  bottom: 3.16rem;
  right: 3.94rem;
  width: 22.94rem;
  height: 12.83rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
    object-position: center;
  }
`;

export const Content = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: ${props => (props.$isMobile ? '100vw' : '40vw')};

  > svg {
    margin-top: 3.5rem;
  }

  form {
    width: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 3.88rem 6.16rem 0 6.16rem;
    max-width: 100%;
    align-items: stretch;
    text-align: flex-start;

    > svg {
      margin: 0 0 8%;
    }

    > h1 {
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.339rem;
    }

    > p.magic-link-description {
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.85rem;
      color: #666;
      line-height: 1.5;
      margin: 0.5rem 0 0;
    }

    > span {
      display: flex;
      justify-content: flex-start;
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.88rem;
      text-align: left;
      margin-top: 8.33%;
      margin-bottom: 1.5%;
    }

    > .primary-button {
      margin-top: 3.05rem;
      margin-bottom: 0.88rem;
      height: 3.33rem;
      font-family: 'RedHatDisplay-Bold';
      font-size: 1.33rem;
      border-radius: 0.55rem;
      box-shadow: 0px 3px 15px rgba(255, 152, 0, 0.3);
    }
  }
  footer {
    width: 100%;
    height: 0.778rem;
    background-color: #ff9800;
  }

  @media (max-width: 1226px) {
    max-width: 100vw;
  }
`;

export const SignInArea = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  a {
    font-size: 0.89rem;
    color: #1e88e5;
    position: relative;
    text-decoration: none;
    transition: color 0.2s ease;
    padding: 0.2rem 0.4rem;
    margin: -0.2rem -0.4rem; /* compensate for padding */
    border-radius: 4px;

    /* Hover effect */
    &:hover {
      color: #0d47a1; /* Slightly darker blue */
      text-decoration: underline;
    }

    /* Focus effect */
    &:focus-visible {
      outline: 2px solid #ff9800;
      outline-offset: 2px;
      text-decoration: underline;
    }

    /* Transition effect
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      transform: scaleX(0);
      height: 2px;
      bottom: -1px;
      left: 0;
      background-color: #ff9800;
      transform-origin: bottom left;
      transition: transform 0.3s ease-out;
    }

    &:hover::after,
    &:focus::after {
      transform: scaleX(1);
    } */
  }
`;

export const Footer = styled.div`
  flex: 1;
  align-items: flex-end;
  width: 100%;
  height: auto;
`;

export const SideContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-height: 100vh !important;

  @media (max-width: 810px) {
    display: none;
  }
`;

export const TopContent = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LanguageButtons = styled.div`
  position: absolute;
  z-index: 1000;
  display: flex;
  top: 3.16rem;
  left: 3.94rem;
  align-items: center;
  color: #ffffff80;

  > button {
    background: none;
    border: 0;
    font-family: 'RedHatDisplay-Regular';
    font-size: 1.22rem;
    color: #ffffff80;

    &.active-language {
      color: #fff;
    }

    &:hover {
      color: #ff9800;
      cursor: pointer;
    }

    &:focus-visible {
      outline: 1px solid #ff9800;
      color: #ff9800;
      outline-offset: 1px;
      text-decoration: underline;
    }
  }

  > button:first-child {
    margin-right: 0.33rem;
  }

  > button:last-child {
    margin-left: 0.33rem;
  }
`;

export const AuthTabs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 6.16rem;
  margin-top: 1.5rem;
  border-bottom: 2px solid #f0f0f0;
`;

export const AuthTab = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  border-bottom: 2px solid
    ${props => (props.$active ? '#ff9800' : 'transparent')};
  margin-bottom: -2px;
  padding: 0.6rem 1rem;
  font-family: 'RedHatDisplay-Bold';
  font-size: 0.88rem;
  color: ${props => (props.$active ? '#ff9800' : '#888')};
  cursor: pointer;
  transition:
    color 0.2s ease,
    border-color 0.2s ease;

  &:hover {
    color: #ff9800;
  }

  &:focus-visible {
    outline: 2px solid #ff9800;
    outline-offset: 2px;
  }
`;

export const MagicLinkSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex: 1;
  padding: 3.88rem 6.16rem;
  gap: 1rem;

  .success-icon {
    font-size: 3.5rem;
  }

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.34rem;
    color: #333;
    margin: 0;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #666;
    line-height: 1.5;
    margin: 0;
  }

  .resend-link {
    background: none;
    border: none;
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.88rem;
    color: #1e88e5;
    cursor: pointer;
    text-decoration: underline;
    margin-top: 0.5rem;

    &:hover {
      color: #0d47a1;
    }

    &:focus-visible {
      outline: 2px solid #ff9800;
      outline-offset: 2px;
    }
  }
`;
